import React, { FC, useCallback } from 'react';
import styles from '../index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { confirm } from 'src/common';
import modalStyles from 'src/common/Modal/index.module.scss';
import { useTranslation } from 'react-i18next';
import { useDeleteMPKeyword } from 'src/models/matchingProfiles/hooks';

interface IProps {
  keywordId: string;
  mpId: string;
}

export const DeleteButton: FC<IProps> = props => {
  const { keywordId, mpId } = props;
  const { t } = useTranslation();

  const [deleteMPKeywords] = useDeleteMPKeyword();

  const onDelete = useCallback(() => {
    confirm.confirm({
      title: t('Tenders.removeKeyword'),
      okText: t('Common.delete'),
      content: t('Tenders.removeKeywordDescription'),
      cancelText: t('Common.cancel'),
      className: modalStyles.confirmModal,
      centered: true,
      onOk() {
        deleteMPKeywords(keywordId, mpId);
      }
    });
  }, [deleteMPKeywords, keywordId, mpId, t]);
  return (
    <button className={styles.deleteButton} onClick={onDelete}>
      <FontAwesomeIcon icon={faTimes} />
    </button>
  );
};

export default DeleteButton;
